import { createContext } from 'react'
import { track } from '@amplitude/analytics-browser'
import { dataset } from '@/api/sanity'
import { AmplitudeInitializer } from './AmplitudeInitializer'

const trackAmplitudeEvent = (eventName, eventProperties) => {
  try {
    track(eventName, eventProperties)
  } catch (error) {
    // Amplitude not initialized or tracking failed - fail silently
    console.debug('Amplitude tracking skipped:', eventName)
  }
}

export const AmplitudeContext = createContext<{ trackAmplitudeEvent?: typeof trackAmplitudeEvent }>(
  {},
)

export function AmplitudeContextProvider({ children }) {
  const isProduction = dataset === 'production'

  if (!isProduction) {
    return <>{children}</>
  }

  return (
    <AmplitudeContext.Provider value={{ trackAmplitudeEvent }}>
      <AmplitudeInitializer isProduction={isProduction} />
      {children}
    </AmplitudeContext.Provider>
  )
}
